import { TableCell } from "@mui/material";
import { useContext, useState } from "react";
import { Button, Modal } from "src/Components";
import { IEnterPairPositionTableReport } from "src/Interfaces/coveredCall";
import {
  IAdditional,
  IAdditionalHeaderProps,
} from "src/Tables/TableTemplate/tableTemplate";
import SendCCOrders from "./SendCCOrders";
import { Edit } from "@mui/icons-material";
import UpdateCriterion from "./UpdateCriterion";
import {
  ICCOrderLeg,
  IUpdateCriterionDTO,
  VolumeCalculationType,
} from "src/Interfaces/ccOrder";
import { DeltaHedgeOrderType } from "src/Interfaces/deltaHedgeOrder";
import { StepOrderSide } from "src/Interfaces/stepInterfaces";
import { EnterPairPositionContext } from "..";

const AdditionalHeader = ({}: IAdditionalHeaderProps) => {
  return (
    <>
      <TableCell>
        <span className="!font-black text-black">سفارش باز</span>
      </TableCell>
      <TableCell />
    </>
  );
};

const AdditionalCol: React.FC<{
  row: IEnterPairPositionTableReport;
  onAction: () => void;
}> = ({ row, onAction }) => {
  enum ModalMode {
    SendOrders,
    Edit,
    Closed,
  }
  const [modalMode, setModalMode] = useState(ModalMode.Closed);
  const { riskProfileId, useFixedBasePrices } = useContext(
    EnterPairPositionContext,
  );

  function getInitialFormValues() {
    const res = {
      coveredCallOrderLegs: [] as ICCOrderLeg[],
      coveredCallOrderSellLeg: {} as ICCOrderLeg,
      orderType: DeltaHedgeOrderType.Open,
      coveredCallPositionStrategyEnum: row.coveredCallPositionStrategyEnum,
      newCriterion: row.openOrdersCriterion
        ? Number(row.openOrdersCriterion)
        : 0,
      criterionType: row.openOrdersCriterionType,
    } as IUpdateCriterionDTO;

    res.coveredCallOrderLegs = [
      {
        instrumentId: row.instrumentId1,
        orderSide: StepOrderSide.Buy,
      },
    ];

    res.coveredCallOrderSellLeg = {
      instrumentId: row.instrumentId3,
      orderSide: StepOrderSide.Sell,
    };

    if (row.coveredCallPositionStrategyEnum === 8)
      res.coveredCallOrderLegs.push({
        instrumentId: row.instrumentId2!,
        orderSide: StepOrderSide.Sell,
      });

    return res;
  }

  const getModalUI = () => {
    switch (modalMode) {
      case ModalMode.SendOrders:
        return (
          <SendCCOrders
            onAction={() => {
              onAction();
              setModalMode(ModalMode.Closed);
            }}
            row={row}
            volumeCalculationType={VolumeCalculationType.Portfo}
            useFixedBasePrices={useFixedBasePrices}
          />
        );

      case ModalMode.Edit:
        return (
          <UpdateCriterion
            instrumentNames={
              row.coveredCallPositionStrategyEnum === 8
                ? [
                    row.buyInstrumentName1!,
                    row.buyInstrumentName2!,
                    row.sellInstrumentName1!,
                  ]
                : [row.buyInstrumentName1!, row.sellInstrumentName1!]
            }
            initialValues={getInitialFormValues()}
            onClose={() => setModalMode(ModalMode.Closed)}
            orderTypeStr="ورود"
            riskProfileId={riskProfileId}
          />
        );

      default:
        return <></>;
    }
  };

  const editHandler = (e: React.MouseEvent<HTMLDivElement>) => {
    e.stopPropagation();
    setModalMode(ModalMode.Edit);
  };

  return (
    <>
      <TableCell>
        <div className="flex flex-row justify-start items-center gap-2">
          <div>{row.openOrderExpr || "-"}</div>
          {row.openOrderExpr ? (
            <div
              className="hover:bg-slate-300 transition-all rounded p-1 cursor-pointer"
              onClick={editHandler}
            >
              <Edit className="text-sky-700 cursor-pointer" />
            </div>
          ) : (
            <></>
          )}
        </div>
      </TableCell>
      <TableCell>
        {modalMode !== ModalMode.Closed ? (
          <Modal
            title={modalMode === ModalMode.SendOrders ? "ارسال سفارش" : "ویرایش"}
            onClose={() => setModalMode(ModalMode.Closed)}
            UI={getModalUI()}
          />
        ) : (
          <></>
        )}
        <Button
          text="ارسال"
          variant="contained"
          onClick={() => {
            if (useFixedBasePrices) return;
            setModalMode(ModalMode.SendOrders);
          }}
          disabled={useFixedBasePrices}
        />
      </TableCell>
    </>
  );
};

export const Additional: IAdditional<IEnterPairPositionTableReport> = {
  getHeader: AdditionalHeader,
  getRow: AdditionalCol,
};
